<template>
  <div class="app-container">
    <BjRouteTabs :route-list="LOGISTICS_COMPANY_ROUTE_LIST" />
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('businessLogisticsCompany.table.logisticsCompanyName2')" prop="name">
            <BjInput v-model="queryParams.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('businessLogisticsCompany.table.logisticsCompanyName2')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('businessLogisticsCompany.common.status')" prop="enableFlag">
            <BjSelectLov v-model="queryParams.enableFlag" :option-list="STATUS_ENABLED_TRUE" :placeholder="$t('businessLogisticsCompany.common.status')" />
          </el-form-item></el-col>
      </template>

      <template v-if="!$store.getters.cusId" v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('businessLogisticsCompany.common.add') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <el-tag v-else-if="col.prop === 'enableFlag'" :type="scope.row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row[col.prop])) }}</el-tag>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
              <el-button v-if="!scope.row.enableFlag" type="text" @click="onStatus(true, scope.row)">{{ $t('enableText') }}</el-button>
              <el-button v-else type="text" @click="onStatus(false, scope.row)">{{ $t('disableText') }}</el-button>
              <el-button :disabled="scope.row.status == 1" type="text" class="delete-btn" @click="onDelete(scope.row)">{{ $t('delText') }}</el-button>
              <el-button type="text" @click="showLog(scope.row)">{{ $t('logText')}}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { logisticApi,settingApi } from '@/api';
import orderLog from '@/utils/log.js';
import { LOGISTICS_COMPANY_ROUTE_LIST, STATUS_ENABLED_TRUE } from '@/utils/constants';
import DataForm from './components/DataForm.vue';
export default {
  name: 'BusinessLogisticsCompanyListIndex',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      LOGISTICS_COMPANY_ROUTE_LIST,
      STATUS_ENABLED_TRUE,
      queryApi: logisticApi.getLogisticsCompany,
      // 查询参数
      queryParams: {
        name: null,
        enableFlag: null,
      },
      labelsVersion: 6,
      labelList: [
        { label: 'businessLogisticsCompany.table.logisticsCompanyName2', prop: 'name', isCheck: true, disabled: false, width: '380px' },
        { label: 'businessLogisticsCompany.table.status', prop: 'enableFlag', isCheck: true, disabled: false },
        { label: 'businessLogisticsCompany.table.creator', prop: 'createdName', isCheck: true, disabled: false },
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false },
        // { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    showLog(row) {
            orderLog(
                this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
                    actionApi:settingApi.logisticsLogList,
                    defaultQuery: {
                      recordId:row.id,
                      recordType:"LOGISTICS PROVIDER"
                    },
                    columns: [
                        {
                            prop: 'createdName',
                            label: 'BjDialogListConfig.Operator',
                        },
                        {
                            prop: 'creationDate',
                            label: 'BjDialogListConfig.Operationtime',
                        },
                        {
                            prop: 'remark',
                            label: 'BjDialogListConfig.Remarks',
                        },
                    ],
                }),
            );
        },
    /** 修改状态 */
    onStatus(flag, row) {
      const TEXT = this.$t(STATUS_ENABLED_TRUE.bjGet(flag));
      this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            id: row.id,
            enableFlag: flag,
            objectVersionNumber: row.objectVersionNumber,
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreDelTipText')} ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: [row.id] });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    /** 新建 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone(row));
    },

    operationApi(API_DATA) {
      logisticApi.updateLogisticsCompany(API_DATA).then(res => {
        if (!res.failed) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      logisticApi.deleteLogisticsCompany(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>
